"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _QCWMNYUYcjs = require('../__chunks/QCWMNYUY.cjs');


var _AVNURAH2cjs = require('../__chunks/AVNURAH2.cjs');
require('../__chunks/STJK5WUW.cjs');


var _B5WROPFJcjs = require('../__chunks/B5WROPFJ.cjs');


var _D7QSSCKRcjs = require('../__chunks/D7QSSCKR.cjs');
require('../__chunks/55GZX7VJ.cjs');
require('../__chunks/UI5KWBYV.cjs');
require('../__chunks/L634CRNJ.cjs');
require('../__chunks/MXP46NZ2.cjs');
require('../__chunks/5MLKOK3F.cjs');
require('../__chunks/YEIU6ILA.cjs');
require('../__chunks/W32FX7DM.cjs');
require('../__chunks/7AMN26AR.cjs');
require('../__chunks/6GRO3ZM4.cjs');
require('../__chunks/VP4WDOZF.cjs');
require('../__chunks/55HRZINU.cjs');
require('../__chunks/2UJOY5ZF.cjs');
require('../__chunks/JLMLKTUB.cjs');
require('../__chunks/LCWSLOYU.cjs');
require('../__chunks/V7JASX7S.cjs');
require('../__chunks/56NPFF7P.cjs');
require('../__chunks/GASMO7Y4.cjs');
require('../__chunks/6IFEN2M3.cjs');
require('../__chunks/26P4PLHI.cjs');
require('../__chunks/YVOQ2BCB.cjs');
require('../__chunks/4SKDRUBR.cjs');
require('../__chunks/AQ2LO7WV.cjs');
require('../__chunks/KEDCOTT4.cjs');
require('../__chunks/WU47XUXM.cjs');
require('../__chunks/OJZKTJL7.cjs');
require('../__chunks/6E4BBKC4.cjs');
require('../__chunks/2XVCJUVB.cjs');
require('../__chunks/VYZTFWCG.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/select/select-popover.tsx
var TagName = "div";
var useSelectPopover = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useSelectPopover2({ store, alwaysVisible, ...props }) {
    const context = _AVNURAH2cjs.useSelectProviderContext.call(void 0, );
    store = store || context;
    props = _QCWMNYUYcjs.useSelectList.call(void 0, { store, alwaysVisible, ...props });
    props = _B5WROPFJcjs.usePopover.call(void 0, { store, alwaysVisible, ...props });
    return props;
  }
);
var SelectPopover = _D7QSSCKRcjs.createDialogComponent.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function SelectPopover2(props) {
    const htmlProps = useSelectPopover(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  }),
  _AVNURAH2cjs.useSelectProviderContext
);



exports.SelectPopover = SelectPopover; exports.useSelectPopover = useSelectPopover;
